import { ActionStatus } from "../../common/constants/action-status";
import { StoreState } from "../../store/store.interface";

export const isLoadingOrderHistory = (state: StoreState) => state.orderHistoryState.status === ActionStatus.loading;
export const getOrderHistoryStatus = (state: StoreState) => state.orderHistoryState.status;
export const getOrderHistoryData = (state: StoreState) => state.orderHistoryState.data;